import { paletteHex, type Category } from '@wiztime/core';

/** Category colours of the summary charts (ui-redesign §5.7): work blue, rest teal, life orange. */
export const CATEGORY_COLOR: Readonly<Record<Category, string>> = {
  work: paletteHex('blue'),
  rest: paletteHex('teal'),
  life: paletteHex('orange'),
};
